<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables">
                <div class="leftsideicons">
                    <img src="../../assets/image/multiple-users.png" alt="multiuser" />
                </div>
                <h3>{{ "Client Offers" }}</h3>
            </div>
        </div>
        <div class="row position">
            <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
                <div class="col-md-2">
                    <div class="srchgrid texttarget">
                        <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)"
                            [value]="searchString" placeholder="Search" autocomplete="off">
                        <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                                aria-hidden="true">&times;</span> </div>
                    </div>
                </div>
                <div class="col-md-10 toogle">
                    <div class="btn-group-offer">
                        <button type="button" class="btn btn-primary addBtn" (click)="openClientOfferDialog(null)">Add
                            Offer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="position">
        <kendo-grid #grid  [loading]='kendoLoading' [data]="gridView" [filter]="state.filter" [sortable]="{mode: 'single'}"
            [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
            [pageable]="gridView?.data?.length && gridView.data.length > 0 ? pageableWithAll : false"
            (pageChange)="pageChange($event)" [sort]="sort" (sortChange)="clientOfferData ? sortChange($event): null"
            [resizable]="true" [reorderable]="true" filterable="menu" [filter]="state.filter" [selectable]="true"
            (dataStateChange)="clientOfferData ? dataStateChange($event): null" [navigable]="true" [height]="gridHeight"
            (columnVisibilityChange)="onColumnVisibilityChange(grid)"
            (dblclick)="onRowDoubleClick($event)">
            <kendo-grid-column field="Name" [width]="100" title="Name">
            </kendo-grid-column>
            <kendo-grid-column field="Email" [width]="100" title="Email">
            </kendo-grid-column>
            <kendo-grid-column field="PlanName" [width]="100" title="Plan Name">
            </kendo-grid-column>
            <kendo-grid-column field="CreatedOn" [width]="100" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.CreatedOn | date: 'dd/MM/YYYY' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="PlanType" [width]="100" title="Plan Type">
            </kendo-grid-column>
            <kendo-grid-column field="PlanDuration" [width]="100" title="Plan Duration">
            </kendo-grid-column>
            <kendo-grid-column field="Notes" [width]="100" title="Note">
            </kendo-grid-column>
            <kendo-grid-column field="CreatedByName" [width]="100" title="Added By">
            </kendo-grid-column>
            <kendo-grid-column field="Action" [width]="100" title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <img src="../../assets/image/edit-appointment-icon.png" alt="Edit Appointment"
                        (keydown.enter)="openClientOfferDialog(dataItem)" class="ico20"
                        (click)="openClientOfferDialog(dataItem)" />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
<ng-template #clientOfferDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header"
                style="margin-bottom:5px; display: flex; align-items: center; justify-content: space-between;">
                <h4 class="popup-title">{{action}} Client Offer</h4>
                <div class="header-actions" style="display: flex; gap: 8px;">
                    <button mat-icon-button (click)="toggleMaximize()">
                        <mat-icon style="margin-top:-22px;">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen'
                            }}</mat-icon>
                    </button>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
                </div>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <form [formGroup]="addClientOfferFrom" class="mat-form">

                        <!-- Row 1 -->
                        <div class="row">
                            <!-- First Name -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>First Name</mat-label>
                                    <input matInput formControlName="Name" placeholder="Enter Name" maxlength="100" />
                                    <mat-error
                                        *ngIf="addClientOfferFrom.get('Name')?.touched && addClientOfferFrom.get('Name')?.invalid">
                                        <ng-container
                                            *ngIf="addClientOfferFrom.get('Name')?.errors?.['required'] || addClientOfferFrom.get('Name')?.errors?.['whitespace']">
                                            First Name is required
                                        </ng-container>
                                        <ng-container *ngIf="addClientOfferFrom.get('Name')?.errors?.['maxlength']">
                                            Maximum 100 characters allowed
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Plan -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Plan</mat-label>
                                    <mat-select formControlName="PlanName" [panelClass]="'custom-select-panel'"
                                        [disableOptionCentering]="true">
                                        <mat-option value="" disabled>Select a Plan</mat-option>
                                        <mat-option *ngFor="let option of planOptions" [value]="option.value">
                                            {{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="addClientOfferFrom.get('PlanName')?.touched && addClientOfferFrom.get('PlanName')?.invalid">
                                        <ng-container
                                            *ngIf="addClientOfferFrom.get('PlanName')?.errors?.['required'] || addClientOfferFrom.get('PlanName')?.errors?.['whitespace']">
                                            Plan Name is required
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 2 -->
                        <div class="row">
                            <!-- Email -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Email</mat-label>
                                    <input matInput type="email" formControlName="Email" placeholder="Enter your email"
                                        maxlength="100" />
                                    <mat-error
                                        *ngIf="addClientOfferFrom.get('Email')?.touched && addClientOfferFrom.get('Email')?.invalid">
                                        <ng-container *ngIf="addClientOfferFrom.get('Email')?.errors?.['required']">
                                            Email is required
                                        </ng-container>
                                        <ng-container *ngIf="addClientOfferFrom.get('Email')?.errors?.['pattern']">
                                            Invalid email format
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Price -->
                            <div class="col-md-6">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Price</mat-label>
                                    <input matInput type="number" formControlName="Price" placeholder="Enter Price"
                                        min="0" />
                                    <mat-error
                                        *ngIf="addClientOfferFrom.get('Price')?.touched && addClientOfferFrom.get('Price')?.invalid">
                                        <ng-container
                                            *ngIf="addClientOfferFrom.get('Price')?.errors?.['required'] || addClientOfferFrom.get('Price')?.errors?.['whitespace']">
                                            Price is required
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 3 -->
                        <div class="row">
                            <!-- Plan Type -->
                            <div class="col-md-6 d-flex align-items-center">
                                <div>
                                    <mat-label class="mb-2 d-block">Plan Type</mat-label>
                                    <mat-radio-group formControlName="PlanType" aria-label="Select Plan Type"
                                        class="d-flex">
                                        <mat-radio-button value="Month" class="me-3">Month</mat-radio-button>
                                        <mat-radio-button value="Year">Year</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <!-- Plan Duration -->
                            <div class="col-md-6 mt-2">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Plan Duration</mat-label>
                                    <input matInput type="number" formControlName="PlanDuration"
                                        placeholder="Enter Plan Duration" min="1" />
                                    <mat-error
                                        *ngIf="addClientOfferFrom.get('PlanDuration')?.touched && addClientOfferFrom.get('PlanDuration')?.invalid">
                                        <ng-container
                                            *ngIf="addClientOfferFrom.get('PlanDuration')?.errors?.['required']">
                                            Plan Duration is required
                                        </ng-container>
                                        <ng-container *ngIf="addClientOfferFrom.get('PlanDuration')?.errors?.['min']">
                                            Plan Duration must be at least 1
                                        </ng-container>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 4 -->
                        <div class="row">
                            <!-- Notes -->
                            <div class="col-md-12">
                                <mat-form-field class="w-100 custom-blue">
                                    <mat-label>Notes</mat-label>
                                    <textarea matInput formControlName="Notes" placeholder="Enter Notes..."
                                        rows="3"></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                    </form>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
                        class="btn btn-secondary" tabindex="-1">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="submitClientOffer()">{{this.action}}</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #sendmailAgainDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header mb-2">
                <h4 class="popup-title">Send Mail</h4>
                <button type="button" class="btn-close" aria-label="Close" mat-dialog-close (click)="NoSend()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <div>Do you want to send the email again?</div>
                </mat-dialog-content>
                <mat-dialog-actions align="end" class="gap-10">
                    <button mat-raised-button type="button" class="btn btn-secondary marginleft-20" tabindex="-1"
                        (click)="NoSend()">No</button>
                    <button mat-raised-button type="button" (click)="sendAgainMail()" class="btn btn-primary"
                        tabindex="0">Yes</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>